<template>
  <main class="newcomer-campaign">
    <section class="campaign-content">
      <img class="campaign-hero" :src="heroImage" alt="新人专享大礼包">
      <img
        class="campaign-coupons"
        :src="couponImage"
        alt="新人专享优惠券，点击注册领取"
        role="button"
        tabindex="0"
        @click="goRegister"
        @keydown.enter="goRegister"
        @keydown.space.prevent="goRegister"
      >
    </section>
  </main>
</template>

<script>
  import pcAuth from '@/utils/pcAuth'

  const publicAsset = fileName => `${process.env.BASE_URL || '/'}${fileName}`

  export default {
    name: 'PcNewcomerCampaign',
    data() {
      return {
        heroImage: publicAsset('newcomer-campaign-hero.jpg'),
        couponImage: publicAsset('newcomer-campaign-coupons.jpg')
      }
    },
    methods: {
      goRegister() {
        if (pcAuth.getToken()) {
          this.$router.push('/pc/member/coupons')
          return
        }
        this.$router.push({ path: '/pc/login', query: { redirect: '/pc/member/coupons' } })
      }
    }
  }
</script>

<style scoped>
  .newcomer-campaign {
    min-width: 1200px;
    height: 100vh;
    overflow-y: auto;
    background: linear-gradient(180deg, #eefaff 0%, #d7f2ff 100%);
    font-family: Arial, "Microsoft YaHei", sans-serif;
  }

  .campaign-content {
    width: 100%;
    min-height: 100%;
    padding-bottom: 72px;
    box-sizing: border-box;
  }

  .campaign-hero {
    display: block;
    width: 100%;
    height: auto;
  }

  .campaign-coupons {
    display: block;
    width: 900px;
    height: auto;
    margin: 44px auto 0;
    border-radius: 18px;
    box-shadow: 0 18px 44px rgba(0, 99, 190, .16);
    cursor: pointer;
  }

  .campaign-coupons:focus { outline: 3px solid rgba(0, 132, 255, .48); outline-offset: 5px; }
</style>
